module.exports = __webpack_public_path__ + "static/img/memo.d1ca17d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/memo.png
// module id = MQm8
// module chunks = 2